import React, { useState } from "react";
import { MdOutlineAlternateEmail } from "react-icons/md";

const EmailInput = ({ id, label, name, value, onChange, autoComplete = "email" }) => {
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (e) => {
    // e.target is always defined for input change events — the prior
    // `e?.target` shape would have thrown a TypeError on the destructure
    // if e were ever undefined. Use a plain access and guard.
    if (!e || !e.target) return;
    const { value } = e.target;
    setInputValue(value);
    if (onChange) onChange(value);
  };
  return (
    <div>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-300 mb-2"
      >
        {label || "Email Address"}
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MdOutlineAlternateEmail size={18} className="text-gray-400" />
        </div>
        <input
          id={id}
          name={name}
          type="email"
          autoComplete={autoComplete}
          value={inputValue}
          onChange={handleInputChange}
          className="pl-10 block w-full rounded-lg py-2.5 pr-4 bg-[var(--lighter-dark)] border border-white/10 focus:border-[#1ec8c8]/60 focus:ring-2 focus:ring-[#1ec8c8]/30 placeholder-gray-500 text-white focus:outline-none transition-colors"
          placeholder="you@example.com"
        />
      </div>
    </div>
  );
};

export default EmailInput;
